import type { ReactNode } from "react";
import { Box, Typography } from "@mui/material";

interface StateMessageProps {
	/** `status` for an empty result (polite), `alert` for a failure (assertive). */
	role: "status" | "alert";
	glyph: ReactNode;
	title: string;
	detail?: ReactNode;
	action?: ReactNode;
}

/** The centred glyph / title / detail / action stack the empty and error states share. */
export function StateMessage({ role, glyph, title, detail, action }: StateMessageProps) {
	return (
		<Box
			role={role}
			sx={{
				flex: 1,
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				justifyContent: "center",
				gap: 0.75,
				textAlign: "center",
				px: 2,
				py: 6,
			}}
		>
			{glyph}
			<Typography variant="subtitle2">{title}</Typography>
			{detail && (
				<Typography variant="body2" color="text.secondary" sx={{ maxWidth: "40ch" }}>
					{detail}
				</Typography>
			)}
			{action && <Box sx={{ mt: 1 }}>{action}</Box>}
		</Box>
	);
}
